export class Login {
    email: string = "";
    password: string = "";
    firstName: string = "";
    lastName: string = "";
    userId: string = "";
    userRole: string = "";
    accessId: number = 0;
    accessLevel: number = -1;
    accessLevelName: string = "";
    isCampus: boolean = false;
    isDISD: boolean = false;
    isRoster: boolean = false;
    active: boolean = false;

    constructor(email: string, password: string, firstName: string, lastName: string, userId: string,
        userRole: string, accessId: number, isCampusUSer: boolean, isDISDUser: boolean, isRosterUser: boolean, accessLevelName: string, active: boolean = false) {
        this.email = email;
        this.password = password;
        this.firstName = firstName;
        this.lastName = lastName;
        this.userId = userId;
        this.userRole = userRole;
        this.isCampus = isCampusUSer;
        this.isDISD = isDISDUser;
        this.accessId = accessId;
        this.accessLevelName = accessLevelName;
        this.active = active;
    }
}

export enum AccessLevel {
    ADMINUSER = 5,
    AGENTUSER = 2,
    CAMPUSUSER = 0,
    //DISDUSER = 0,
    DISTRICTUSER = 1,
    STATEUSER = 3,
    VIEWONLYUSER = 4,
    IT = 9
}
